<template>
    <v-container>
        <v-row v-if="verlistado">
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Documentación Pendiente
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-archive-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table :headers="header"
                                              item-key="npid"
                                              :loading="show"
                                              loading-text="Cargando... espere un momento"
                                              no-data-text="No hay datos disponibles"
                                              :items="docto"
                                              :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">>
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn color="success"
                                               v-on:click="RecibirDocto(item);"
                                               small
                                               fab
                                               dark>
                                            <v-icon>
                                                mdi-archive-arrow-down-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import Recepcion from '@/services/TramitePago/TramitePago.Service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: function() {
            return {
                docto: [],
                header: [
                    { text: 'Abogado', value: 'Abogado', class: "text title" },
                    { text: 'Paquetería', value: 'pqnombre', class: "text title" },
                    { text: 'Guía', value: 'npguia', class: "text title" },
                    { text: 'Observación', value: 'npobs', class: "text title" },
                    { text: 'Fecha de Envío', value: 'npfhenvio', class: "text title" },
                    { text: 'Acción', value: 'actions', sortable: false },
                ],
                show: true,
                verlistado: true,
                verdocto: false,
                enviardocto: false,
                documento: [],
            }
        },
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ])
        },
        methods: {
            DocumentacionPendiente() {
                Recepcion.DocumentacionPendiente(this).then(data => {
                    if (data.length > 0) {
                        if (data[0].hasOwnProperty('success')) {
                        }
                        else {
                            this.docto = data;
                            this.show = false;
                        }
                    }
                    else
                        this.show = false;
                });
            },
            RecibirDocto(item) {
                this.$router.push({ name: `RecepcionDocto`, params: { docto: item } });
            },
            EnviarDocto(item) {
                this.documento = item;
                this.enviardocto = true;
                this.verlistado = false;
            }
        },
        mounted() {
            
            this.DocumentacionPendiente();
        }
    }
</script>